import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";
import { useHistory } from "react-router-dom";

/**
 * این کامپوننت برای نمایش مدال کنسل کردن سفارش است
 * این مدال در جدول سفارشات استفاده شده است
 */
const ModalRollback = ({
  showitem,
  handleCloseMoudal,
  id,
  handeldeleteitem,
  access,
}) => {
  const [acceptOneBtn, setAcceptOneBtn] = useState(false);
  const [acceptTwoBtn, setAcceptTwoBtn] = useState(false);
  const [acceptThreeBtn, setAcceptThreeBtn] = useState(false);
  const { location } = useHistory();
  const [loading, setLoading] = useState(false);
  const allConditions = acceptOneBtn && acceptTwoBtn && acceptThreeBtn;
  const [dataForm, setDataForm] = useState({ id });

  const { urldashboard, authentication, urlPatch } =
    useContext(DashboardContext);

  const [controllerName, setControllerName] = useState(
    location.pathname.split("/")[1].replace("/", "")
  );

  const sendData = async () => {
    try {
      const res =
        access === "/PeriodOrder"
          ? await Axios.post(
              `${urldashboard}/periodorder/cancel `,
              JSON.stringify(dataForm),
              {
                headers: {
                  Authorization: authentication,
                  "content-type": "application/json; charset=utf-8",
                },
              }
            )
          : await Axios.put(
              `${urldashboard}/${controllerName}/cancel`,
              JSON.stringify(dataForm),
              {
                headers: {
                  Authorization: authentication,
                  "content-type": "application/json; charset=utf-8",
                },
              }
            );

      const data = await res.data;
      toast.success(data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLoading(false);
      handeldeleteitem();
      handleCloseMoudal();
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error("اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(error.response.data.message, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };
  const Rollback = async () => {
    const params = {
      orderScheduleId: id,
    };
    setLoading(true);
    try {
      const res = allConditions
        ? await Axios.put(urldashboard + "/order/rollback", params, {
            headers: {
              Authorization: authentication,
              "Content-Type": "application/json",
            },
          })
        : null;
      toast.success(res?.data?.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handleCloseMoudal();
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
        setLoading(false);
    }
    // setAcceptBtn(true)
  };

  useEffect(() => {
    if (location.pathname.includes("Customer")) {
      setControllerName("order");
    }
  }, []);

  const handelsubmit = () => {
    setLoading(true);

    if (!dataForm.description) {
      toast.error("لطفا توضیحات وارد کنید", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setLoading(false);
    } else {
      // sendData()
    }
  };
  return (
    <Modal
      contentClassName='modal-rollback-height'
      size='lf'
      className='lg-rollback'
      show={showitem}
      onHide={handleCloseMoudal}
    >
      <Modal.Header>
        <Modal.Title>فرم بازگشت از پایان کار کارلاین</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body>
        <Col lg='12' md='12' sm='12' xs='12'>
          <div className='d-flex align-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              style={{ marginLeft: "2%" }}
              width='40'
              height='40'
              fill='#ff3333'
              className='bi bi-exclamation-triangle'
              viewBox='0 0 16 16'
            >
              <path d='M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z' />
              <path d='M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z' />
            </svg>
            <span style={{ color: "#00528c", fontSize: " 20px" }}>
              {" "}
              جهت بازگرداندن وضعیت سفارش به قبل از ثبت پایان کار، اصلاح اطلاعات
              مالی ثبت شده برای مشتری و نیروهای آن سفارش الزامی است.
            </span>
          </div>
          <div className='form-group'>
            <br />
            <hr />
            <b style={{ fontSize: " 18px" }}>
              اطمینان دارم مراحل مالی بازگشت از پایان کار شامل :
            </b>
            <br />
            <br />
            <div style={{ paddingRight: "2%" }}>
              <div className='d-flex align-items-start'>
                <input
                  style={{ width: 13, height: 20, marginLeft: "2%" }}
                  type='checkbox'
                  // onChange={(e) => {setDataForm({ ...dataForm, sendSms: e.target.checked })} }
                  onChange={() => setAcceptOneBtn(!acceptOneBtn)}
                  name='name'
                />
                <label style={{ margin: 0, fontSize: 18 }}>
                  بخش مالی کیف پول و یا رسیدهای ثبت شده مشتری در بخش پروفایل
                  مشتری بررسی و اصلاح شده است و مورد دیگری برای اصلاح وجود
                  ندارد.
                </label>
              </div>
              <br />

              <div className='d-flex align-items-start'>
                <input
                  style={{ width: 13, height: 20, marginLeft: "2%" }}
                  type='checkbox'
                  // onChange={(e) => {setDataForm({ ...dataForm, sendSms: e.target.checked })} }
                  onChange={() => setAcceptTwoBtn(!acceptTwoBtn)}
                  name='name'
                />
                <label htmlFor='' style={{ fontSize: " 18px", margin: 0 }}>
                  بخش مالی کیف پول و رسیدهای ثبت شده نیروها در بخش پروفایل
                  نیروها بررسی و اصلاح شده است و مورد دیگری برای اصلاح وجود
                  ندارد.
                </label>
              </div>
              <br />

              <div className='d-flex align-items-start'>
                <input
                  style={{ width: 13, height: 20, marginLeft: "2%" }}
                  type='checkbox'
                  // onChange={(e) => {setDataForm({ ...dataForm, sendSms: e.target.checked })} }
                  onChange={() => setAcceptThreeBtn(!acceptThreeBtn)}
                  name='name'
                />
                <label style={{ fontSize: " 18px", margin: 0 }} htmlFor=''>
                  {" "}
                  تمام اصلاحیه های مالی مربوط به این سفارش بررسی و اصلاح شده
                  است.
                </label>
              </div>
              <br />
              <br />
              {/* <div className="d-flex align-center">
                                <input style={{ width: 20, height: 20,marginLeft:'2%' }} type="checkbox"
                                    // onChange={(e) => {setDataForm({ ...dataForm, sendSms: e.target.checked })} } 
                                    onChange={() => setAcceptBtn(!acceptBtn)}
                                    name="name" /> */}
              {/* {" "}
                                  موارد گفته شده را تایید می نمایم.   */}
              {/* </div> */}
            </div>
          </div>
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' disabled={loading} onClick={handleCloseMoudal}>
          بستن
        </Button>
        <Button
          variant={allConditions ? "success" : ""}
          disabled={!allConditions || loading}
          onClick={Rollback}
          style={{ border: allConditions ? "none" : "1px solid #0ddbb9" }}
        >
          {loading ? (
            <i className='fa fa-spinner fa-pulse fa-fw'></i>
          ) : (
            "تایید نهایی بازگشت از پایان کار"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRollback;
